// Angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule } from "@angular/common/http";
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
// Kendo
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { PanelBarModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
// Components
import { HomeComponent } from './components/form/home/home.component';
import { EditComponent } from './components/form/edit/edit.component';
import { MenuBarComponent } from './components/system/menu-bar/menu-bar.component';
import { PersonalSafetyComponent } from './components/form/ehs/personalSafety/personalSafety.component';
import { ProcessSafetyComponent } from './components/form/ehs/processSafety/processSafety.component';
import { InjuryFreeDaysComponent } from './components/form/ehs/injuryFreeDays/injuryFreeDays.component';
import { InstallComponent } from './components/system/install/install.component';
// Local Services
import { SettingsProvider } from './services/settings-provider.service';
import { GlobalService } from './services/global.service';
import { UpdateApplication } from './services/update-application.service';
import { AuthenticationModule } from './authentication/authentication.module';
// Charts
// import { ChartModule } from 'angular2-highcharts';
// import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
// import HighchartsMore from 'highcharts/highcharts-more';
// import SolidGauge from 'highcharts/modules/solid-gauge';

// Gauge
import { GaugesModule } from './guages/index';
import { GraphService } from './services/graphs.service';
import { RouterModule } from '@angular/router';
import { OnshoreOffshoreProdVolComponent } from './components/form/ops/onshoreOffshoreProdVol/onshoreOffshoreProdVol.component';
import { OnshoreOffshoreProdTypeComponent } from './components/form/ops/onshoreOffshoreProdType/onshoreOffshoreProdType.component';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { WellsDrilledandConnectedComponent } from './components/form/ops/wellsdrilledandconnected/wellsdrilledandconnected.component';
import { AgGridModule } from 'ag-grid-angular';
import { ExplorationWellsComponent } from './components/form/ops/explorationWells/explorationWells.Component';
import { TargetCellRenderer } from './components/form/ops/explorationWells/target-cell-renderer.component';
import { SalesRevenueComponent } from './components/form/fin/salesRevenue/salesRevenue.component';
import { UpstreamUnitProductionCostComponent } from './components/form/fin/upstreamUnitProductionCost/upstreamUnitProductionCost.component';
import { FreeCashFlowComponent } from './components/form/fin/freeCashFlow/freeCashFlow.component';
import { GearingComponent } from './components/form/fin/gearing/gearing.component';
import { UserModel } from './models/user.model';


declare var require: any;

// export function highchartsFactory() {
//     const a = require('highcharts');
//     const b = require('highcharts/highcharts-more');
//     const c = require('highcharts/modules/solid-gauge');
//     b(a);
//     c(a);
//     return a;
// }

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        EditComponent,
        MenuBarComponent,
        PersonalSafetyComponent,
        ProcessSafetyComponent,
        InjuryFreeDaysComponent,
        InstallComponent,
        OnshoreOffshoreProdVolComponent,
        OnshoreOffshoreProdTypeComponent,
        WellsDrilledandConnectedComponent,
        ExplorationWellsComponent,
        TargetCellRenderer,
        SalesRevenueComponent,
        UpstreamUnitProductionCostComponent,
        FreeCashFlowComponent,
        GearingComponent
    ],
    imports: [
        // ChartModule.forRoot(
        //     require('highcharts'),
        // //    require('highcharts/modules/exporting'),
        //     require('highcharts/highcharts-more'),
        //     require('highcharts/modules/solid-gauge')
        //   ),
        BrowserModule,
        HighchartsChartModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ButtonsModule,
        DialogModule,
        InputsModule,
        LabelModule,
        PanelBarModule,
        FormsModule,
        DatePickerModule,
        AuthenticationModule,
        HttpClientModule,
        HttpClientJsonpModule,
        GaugesModule,
        GridModule,
        ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
        RouterModule,
        DropDownListModule,
        AgGridModule.withComponents([TargetCellRenderer])
    ],
    providers: [
        UpdateApplication,
        // {
        //     provide: HighchartsStatic,
        //     useFactory: highchartsFactory
        // },
        SettingsProvider,
        {
            'provide': APP_INITIALIZER,
            'useFactory': initialiseSettings,
            'deps': [SettingsProvider],
            'multi': true
        },
        GlobalService,
        GraphService,
        UserModel

    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function initialiseSettings(settingsProvider: SettingsProvider) {
    return () => settingsProvider.loadConfig();
}